<template>
  <div class="float-form-component">
    <v-btn
      v-if="!showForm"
      @click="showForm = true"
      fab
      fixed
      color="#2C3A7B"
      right
      bottom
    >
      <v-icon color="white"> $vuetify.icons.chat </v-icon>
    </v-btn>
    <v-scroll-y-reverse-transition>
      <v-card v-if="showForm" class="float-form-card">
        <v-card-title class="float-form-card-title">
          <v-icon color="grey" small class="mr-2"> $vuetify.icons.chat </v-icon>
          {{$t('floatForm.feedback')}}
          <v-spacer />
          <v-btn icon small @click="showForm = false">
            <v-icon small> fa-times </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4">
          <div v-show="formSended" class="success-form-send text-center">
            <div class="">
              {{$t('formComponent.thankyForRequest')}}
            </div>
            <v-btn
              color="#549EC7"
              tile
              class="submit-form-button elevation-0 mt-5"
              @click="resetForm()"
              >{{$t('formComponent.agree')}}</v-btn
            >
          </div>
          <v-form v-show="!formSended" ref="form" @submit.prevent="submit">
            <div>
              <label> {{$t('floatForm.name')}}</label>
              <v-text-field
                :rules="required"
                outlined
                dense
                v-model="floatForm.fullName"
              />
            </div>
            <div>
              <label> {{$t('formComponent.numberOfphone')}} </label>
              <v-text-field
                v-mask="'###-###-##-##'"
                prefix="+38"
                outlined
                dense
                :rules="phone"
                v-model="floatForm.phone"
              />
            </div>
            <div>
              <label>E-mail *</label>
              <v-text-field
                outlined
                :rules="email"
                dense
                v-model="floatForm.email"
              />
            </div>
            <div>
              <label>{{$t('formComponent.summary')}}</label>
              <v-textarea
                outlined
                :rules="required"
                hide-details
                v-model="floatForm.question"
              />
            </div>
            <div class="captcha-text mt-4">
              <app-captcha
                ref="recaptcha"
                :isBudgeHidden="true"
                @verify="sendForm($event)"
              />
            </div>
            <v-card-actions>
              <router-link
                @click.native="showForm = false"
                class="contacts"
                :to="{
                  name: 'subDynamic',
                  params: { urlKey: 'ourcompany', subUrlKey: 'contact' }
                }"
              >
                {{$t('floatForm.contact')}}
              </router-link>
              <v-spacer> </v-spacer>
              <v-btn
                type="submit"
                elevation="0"
                color="#549EC7"
                :loading="loading"
                tile
                class="submit-form-button"
              >
                {{$t('formComponent.send')}}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-scroll-y-reverse-transition>
  </div>
</template>
<script>
import serviceDataAccess from '../../services/service.data-access'
import { phone, required, email } from '../../utils/validation-rules'
import AppCaptcha from '../_shared/AppCaptcha.vue'
export default {
  components: { AppCaptcha },
  name: 'FloatForm',
  data: () => ({
    showForm: false,
    floatForm: {},
    formSended: false,
    loading: false,
    emailRules: [
      v => !!v || 'E-mail обов\'язковий',
      v => /.+@.+\..+/.test(v) || 'E-mail має невірний формат'
    ]
  }),
  computed: {
    required: () => [required],
    phone: () => [phone],
    email: () => [required, email]
  },
  methods: {
    async sendForm(token) {
      const isValid = await this.$refs.form.validate()
      try {
        if (isValid) {
          this.loading = true
          this.floatForm.googleReCaptchaResponse = token
          await serviceDataAccess.sendFeedbackEmail(this.floatForm)
          this.formSended = true
        }
      } catch (e) {
        this.$uiService.error('Помилка відправки форми')
      } finally {
        this.loading = false
      }
    },
    submit() {
      this.$refs.recaptcha.execute()
    },
    resetForm() {
      this.$refs.form.reset()
      this.showForm = false
      this.formSended = false
    }
  }
}
</script>
<style lang="scss" scoped>
.float-form-card {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 2;
  max-width: 400px;
  width: calc(100% - 32px);

  .float-form-card-title {
    background-color: #eff0f3;
  }
  .captcha-text {
    font-size: 1.2rem;
  }
  .v-input {
    margin-top: 0.4rem;
  }

  label,
  .success-form-send {
    font-size: 1.7rem;
    line-height: 2rem;
  }
  .contacts {
    font-size: 1.7rem;
    text-decoration: none;
    color: gray;
  }
}
</style>
